export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

type DemoItem = {
    key: number
    kind: 'summary' | 'action'
    title: string
    content: string
};

interface Props {
    items: DemoItem[]
}

function createItems(): DemoItem[] {
    return [
        {
            key: 1,
            kind: 'summary',
            title: '需求结论',
            content: '本轮先交付 BubbleList 首版，覆盖滚动、历史加载、空态与插槽扩展能力。',
        },
        {
            key: 2,
            kind: 'action',
            title: '后续动作',
            content: '补充方法调用 demo，并确认 scrollToKey 在自定义 item 场景下仍可正常定位。',
        },
        {
            key: 3,
            kind: 'summary',
            title: '测试状态',
            content: '核心能力已补齐用例，可以继续朝发版标准收口。',
        },
    ];
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            items: createItems(),
        };
    }

    getRowClass(kind: DemoItem['kind']) {
        return `bubble-list-demo-custom-item-row bubble-list-demo-custom-item-row-${kind}`;
    }

    getKindTagType(kind: DemoItem['kind']) {
        return kind === 'summary' ? 'success' : 'default';
    }
}